import { useState } from 'react';
import { flagUrl, teamLogoUrl } from 'services/api/matchDetailsService';

/** A team's crest (BetsAPI image, through our /img), or nothing when it has
 *  none or it does not load. */
export const TeamCrest = ({
  imageId,
  size = 's',
  className,
}: {
  imageId?: string;
  size?: 's' | 'm' | 'b';
  className?: string;
}) => {
  const [failed, setFailed] = useState(false);
  const src = teamLogoUrl(imageId, size);
  if (!src || failed) return null;
  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      className={className}
      onError={() => setFailed(true)}
    />
  );
};

/** A country's flag by its two-letter code, or nothing. */
export const CountryFlag = ({
  cc,
  className,
}: {
  cc?: string | null;
  className?: string;
}) => {
  const [failed, setFailed] = useState(false);
  const src = flagUrl(cc);
  if (!src || failed) return null;
  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      className={className}
      onError={() => setFailed(true)}
    />
  );
};
